import type { PropsWithChildren, ReactNode } from 'react';
import noop from 'lodash/fp/noop';
import type { SwipeableDrawerProps } from '@mui/material';
import { SwipeableDrawer } from '@mui/material';
import useStyles from './BottomSheet.styles';
import { useModalBackButton } from '@/ui/kit/utils/modal-back-button';
import { DialogTitle } from '../dialog-title';
interface IBottomSheet extends Omit<SwipeableDrawerProps, 'open' | 'onOpen' | 'onClose'> {
  title?: string;
  closeButton?: boolean;
  headerIcon?: ReactNode;
  open: boolean;
  onOpen?: SwipeableDrawerProps['onOpen'];
  onClose: () => void;
  titleElement?: ReactNode;
}
export type BottomSheetProps = PropsWithChildren<IBottomSheet>;
export const BottomSheet = ({
  title,
  closeButton = true,
  headerIcon,
  PaperProps,
  children,
  onOpen,
  onClose,
  titleElement,
  ModalProps,
  keepMounted,
  ...restProps
}: BottomSheetProps) => {
  const {
    classes,
    cx
  } = useStyles();
  useModalBackButton({
    open: restProps.open,
    onClose
  });
  return <SwipeableDrawer style={{
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  }} disableSwipeToOpen anchor='bottom' ModalProps={{
    keepMounted: keepMounted ?? false,
    ...ModalProps
  }} PaperProps={{
    ...PaperProps,
    className: cx(PaperProps?.className, classes.paper)
  }} onClose={onClose} onOpen={onOpen || noop} {...restProps} data-sentry-element="SwipeableDrawer" data-sentry-component="BottomSheet" data-sentry-source-file="BottomSheet.tsx">
      {titleElement === undefined ? (title || closeButton) && <DialogTitle headerIcon={headerIcon} onClose={onClose} style={{
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between'
    }}>
              {title}
            </DialogTitle> : titleElement}
      {children}
    </SwipeableDrawer>;
};